import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsRescheduleAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;
	const documentTypeArray = ['EGD018', 'EGD020', 'EGD031', 'EGD033'];

	return !coverProcessId && !!documentType && documentCategory ===  "EGD07"
	          && !documentTypeArray.includes(documentType)? { checkDocCategoryIsRescheduleAndDocTypeAllowedFlag: true } : null;
};
